import { render, staticRenderFns } from "./JourneyFormGoodsTable.vue?vue&type=template&id=2297e19a&scoped=true&"
import script from "./JourneyFormGoodsTable.vue?vue&type=script&lang=js&"
export * from "./JourneyFormGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./JourneyFormGoodsTable.vue?vue&type=style&index=0&id=2297e19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297e19a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField})
